import script from "./Careers.vue?vue&type=script&setup=true&lang=js"
export * from "./Careers.vue?vue&type=script&setup=true&lang=js"

import "./Careers.vue?vue&type=style&index=0&id=84b4c67c&scoped=true&lang=css"

import exportComponent from "/home/appiah/Documents/projects/greenfield/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84b4c67c"]])

export default __exports__